import React from "react";
import { Link } from "react-router-dom";
import { useT } from "@/i18n/LanguageContext";
import { ShieldCheck, Mail, Instagram, Youtube } from "lucide-react";

const Footer = () => {
  const { t, lang } = useT();
  const sm = t.nav?.stockMarket || "Stock Market";
  return (
    <footer className="relative border-t border-white/10 bg-black/40 mt-20" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2">
              <ShieldCheck className="h-6 w-6 text-[#D4AF37]" />
              <span className="font-display text-xl font-extrabold">
                CHINTA<span className="text-[#D4AF37]">MAT</span>
              </span>
            </div>
            <p className="mt-3 text-sm text-white/65 max-w-xs leading-relaxed">{t.footer.tagline}</p>
            <p className="mt-6 text-xs text-white/40 leading-relaxed">{t.footer.disclaimer}</p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-[#D4AF37] mb-4 font-mono-alt">
              {t.footer.sections.platform}
            </div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/#loss-categories" className="text-white/70 hover:text-white">{t.nav.reportCta}</Link></li>
              <li><Link to="/education" className="text-white/70 hover:text-white">{t.nav.education}</Link></li>
              <li><Link to="/blog" className="text-white/70 hover:text-white">Blog</Link></li>
              <li><Link to="/stories" className="text-white/70 hover:text-white">{t.nav.stories}</Link></li>
              <li><Link to="/red-flags" className="text-white/70 hover:text-white">{t.nav.redFlags}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-[#D4AF37] mb-4 font-mono-alt">{sm}</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/risk-checker" className="text-white/70 hover:text-white">{t.nav.risk}</Link></li>
              <li><Link to="/database" className="text-white/70 hover:text-white">{t.nav.database}</Link></li>
              <li><Link to="/mentors" className="text-white/70 hover:text-white">{t.nav.mentors || "Mentors"}</Link></li>
              <li><Link to="/report" className="text-white/70 hover:text-white">{t.nav.reportTradingLoss || "Report trading loss"}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-widest text-[#D4AF37] mb-4 font-mono-alt">
              {t.footer.sections.connect}
            </div>
            <div className="flex flex-col gap-2">
              <a href="mailto:support@chintamat.com" className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-[#D4AF37] transition-colors" data-testid="footer-email">
                <Mail className="h-4 w-4" /> support@chintamat.com
              </a>
              <a href="https://www.instagram.com/chintamat_hq" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-[#D4AF37] transition-colors" data-testid="footer-instagram">
                <Instagram className="h-4 w-4" /> @chintamat_hq
              </a>
              <a href="https://www.youtube.com/@chintamat" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-[#D4AF37] transition-colors" data-testid="footer-youtube">
                <Youtube className="h-4 w-4" /> @chintamat
              </a>
              <Link to="/about" className="text-sm text-white/70 hover:text-white mt-2">{t.nav.about}</Link>
              <Link to="/contact" className="text-sm text-white/70 hover:text-white">{t.nav.contact}</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-white/40">{t.footer.rights}</div>
          <div className={`text-xs ${lang === "hi" ? "lang-hi" : ""} text-white/40 max-w-xl`}>
            {lang === "hi"
              ? "यह वेबसाइट SEBI, RBI, या भारत सरकार से संबद्ध नहीं है। यह एक स्वतंत्र जन-हित मंच है।"
              : "This site is not affiliated with SEBI, RBI, or the Government of India. It is an independent public-interest platform."}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
